import { Box, ButtonBase, Menu, MenuItem, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import TSIcon from "../TSIcon";
import { useTheme } from "@emotion/react";

const LabelRoute = ({ isMobile, ...route }) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  // Toggle dropdown
  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const iconStyle = {
    color: theme.mode === "light" ? "#000000" : "#FFFFFF",
  };

  return (
    <Box
      key={route.key}
      sx={{
        ml: 2,
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
      }}
    >
      <Typography
        sx={{
          cursor: route.children?.length > 0 || route?.disabled ? "default" : "pointer",
          fontFamily: "Sora",
          fontSize: isMobile ? "10px" : "18px",
          fontWeight: "300",
          lineHeight: "22.68px",
          textAlign: "left",
          textUnderlinePosition: "from-font",
          textDecorationSkipInk: "none",
          color: theme.mode === "light" ? "#000000" : "#FFFFFF",
        }}
        onClick={() => {
          if(route.disabled) return
          if (route?.dialog) {
            route?.setOpenLoginDialog(true);
          } else if (route?.path && !(route.children?.length > 0)) {
            navigate(route.path);
          }
        }}
      >
        {route?.label}
      </Typography>

      {route?.children && (
        <ButtonBase
          onClick={handleOpen}
          sx={{ ml: 1, display: "flex", alignItems: "center" }}
        >
          <TSIcon
            icon={Boolean(anchorEl) ? "ArrowDropUpIcon" : "ArrowDropDownIcon"}
            sx={iconStyle}
          />
        </ButtonBase>
      )}

      {route?.children && (
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          {route.children.map((child, index) => (
            <MenuItem
              key={index}
              diasabled={child.disabled}
              onClick={() => {
                if(child.disabled) return
                handleClose();
                if (child.path) {
                  navigate(child.path);
                }
              }}
            >
              <Typography sx={{ fontFamily: "Sora", fontSize: "16px", color: "#000000" }}>{child.label}</Typography>
            </MenuItem>
          ))}
        </Menu>
      )}
    </Box>
  );
};

export default LabelRoute;
